import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { makeResetCache, fetchApi, notifyResponse, notifyError, makeCompoundPayload } from 'gossamer-front-end';
import { User, UserView } from 'cb-model';

export interface SkipAllEmailSendingButtonProps {
  userId: string;
}

export const SkipAllEmailSendingButton = (props: SkipAllEmailSendingButtonProps): React.JSX.Element => {
  const dispatch = useDispatch();
  const resetCache = makeResetCache(dispatch);
  const isProcessing = React.useRef(false);

  const handleSkipAllEmailSending = async () => {
    const check = confirm('Are you sure? This action cannot be reversed.');
    if (!check) {
      return;
    }
    if (isProcessing.current) {
      return;
    }
    try {
      isProcessing.current = true;
      const payload = makeCompoundPayload('save');
      payload.rows.push({
        entityId: User.id,
        action: 'U',
        key: props.userId,
        data: {
          skip_all_email_sending: true,
        },
      });
      const resp = await fetchApi('POST', `/main/~/skip-all-email-sending`, payload);
      resetCache(User.id, props.userId);
      resetCache(UserView.id, props.userId);
      notifyResponse(resp);
    } catch (e) {
      notifyError(e, 'An error occurred while updating skip all email sending setting');
    }
    isProcessing.current = false;
  };

  return (
    <Button type="button" size="sm" variant="warning" onClick={handleSkipAllEmailSending}>
      Skip All Email Sending
    </Button>
  );
};
